export default {
    //获取品类商品全部列表
    getCategoryListAll: "client/product/category/skipAuth/allList",
    //通过key 搜索
    findAssociateWord: "client/search/skipAuth/findAssociateWord",
    //通过keyword 搜索
    productSearch: "client/search/skipAuth/searchProductList",
    //商品 标准库筛选商品
    productSelect: "client/search/skipAuth/filterProductList",
    //商品 获取属性 || 标准库
    getStdlibList: "client/search/skipAuth/findShowStdLibList",
    //过滤标准库
    fiterStdlibList: "client/search/skipAuth/findFilterStdlib",
    //获取商品详情
    getProductInfo: "client/product/main/skipAuth/detail",
};
